module.exports = __webpack_public_path__ + "img/max-speed.5133372a.svg";